module.exports = "<div ba-panel ba-panel-title=\"{{ 'Logs'  | translate }}\" ba-panel-class=\"\">\n    <div class=\"text-right\">\n        <a class=\"btn btn-md btn-danger\" ng-click=\"$ctrl.clearLogs()\" translate>Clear old logs</a>\n    </div>\n    <br>\n    <logs-grid on-page-change=\"$ctrl.onPageChange($page)\"\n               initial-params=\"$ctrl.initialParams\"\n               on-params-change=\"$ctrl.onParamsChange($params)\"></logs-grid>\n\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsPages/Logs/logs.html
// module id = 927
// module chunks = 0